import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  getApiProductsGroupsOptions,
  getApiProductsOptions,
  type GetApiProductsError,
  type GetApiProductsGroupsError,
  type PageOfProductDto,
} from '@/api';

import {
  toActivityQuery,
  toProductsQuery,
  type ActivityFilter,
  type ResolvedProductsSearch,
} from '../lib/searchParams';

/*
 * Чтение справочника товара и списка его групп.
 *
 * Отдельной фабрики ключей здесь нет намеренно: кодогенератор уже строит ключ из
 * имени операции и query-параметров (getApiProductsQueryKey), и своя копия только
 * разошлась бы с ней. Справочник только читается - инвалидировать нечего.
 */
export const useProductsList = (
  resolved: ResolvedProductsSearch,
  // Тип возврата задан явно: без него TypeScript выводит ссылку на внутренний
  // путь сгенерированного пакета и жалуется на непереносимость (TS2742).
): UseQueryResult<PageOfProductDto, GetApiProductsError> =>
  useQuery({
    ...getApiProductsOptions({ query: toProductsQuery(resolved) }),
    // Страница уже показана - на смене фильтра держим её на экране, пока едет
    // следующая, вместо мигания скелетом.
    placeholderData: (previous) => previous,
  });

/**
 * Группы номенклатуры для фильтра - у позиций той же доступности, что и список:
 * в «снятых» видны группы снятых позиций.
 */
export const useProductGroups = (
  activity: ActivityFilter,
): UseQueryResult<Array<string>, GetApiProductsGroupsError> => {
  const query = toActivityQuery(activity);

  return useQuery(
    getApiProductsGroupsOptions(
      query ? { query: { Activity: query } } : undefined,
    ),
  );
};
